/**
 * Requests Page
 * Designer inbox for incoming project requests from homeowners
 */

import { Inbox } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FloatPanel } from "@/features/studio/theme";
import { DesignerProposalsView } from "./proposals";

export function RequestsPage() {
	const { t } = useTranslation();

	return (
		<div className="min-h-screen bg-transparent p-4 sm:p-12">
			<div className="mx-auto max-w-5xl space-y-8">
				{/* Top Masthead Panel */}
				<FloatPanel
					elevation={1}
					padding={32}
					style={{ background: "var(--color-dashboard-paper)" }}
				>
					<div>
						<p
							className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold"
							style={{
								background:
									"color-mix(in srgb, var(--color-dashboard-accent) 10%, transparent)",
								color: "var(--color-dashboard-accent-dark)",
							}}
						>
							<Inbox className="h-3.5 w-3.5" />
							INBOX
						</p>
						<h1
							style={{
								fontFamily: "var(--font-display)",
								fontWeight: 500,
								fontSize: 36,
								color: "var(--color-dashboard-text)",
								letterSpacing: "-0.02em",
								margin: "8px 0 0",
							}}
						>
							Project{" "}
							<span
								style={{
									fontFamily: "var(--font-display)",
									fontStyle: "italic",
									color: "var(--color-dashboard-accent-display)",
								}}
							>
								Requests
							</span>
						</h1>
						<p
							style={{
								fontFamily: "var(--font-body)",
								fontSize: 14,
								color: "var(--color-dashboard-muted-dark)",
								marginTop: 8,
								maxWidth: 600,
							}}
						>
							{t("proposals.designerSubtitle")}
						</p>
					</div>
				</FloatPanel>

				{/* Designer Proposals Feed */}
				<div className="space-y-4">
					<DesignerProposalsView />
				</div>
			</div>
		</div>
	);
}
